<script>
  // export const SketchfabUID = 'b366131a99f34d45b2fff36a03f8e6e0';
  // export const SketchfabUID = 'af22ba76facc4c6e89e5132154c3dd35';
  export let uid;

  //   let SketchfabUID = 'af22ba76facc4c6e89e5132154c3dd35';

  const initializeRemarkable = () => {
    // console.log(`mounted loadStripeElements`);
    //var uid = "8e02c235b92644548f2966e9bd746d8a";
    //https://sketchfab.com/3d-models/trappe-8e02c235b92644548f2966e9bd746d8a
    // Trapes 3D par benjaminp - compte PRO (autorise backgrund transparent)
    //var uid = "b366131a99f34d45b2fff36a03f8e6e0";

    // var uid = SketchfabUID;

    // var uid = "b366131a99f34d45b2fff36a03f8e6e0";
    // var uid = "1c3f17f3d3f641b799ce8bb7ff787f79";
    // var uid = "af22ba76facc4c6e89e5132154c3dd35";

    //https://sketchfab.com/3d-models/3d-model-test-1-8fd5394c3d554e76bb9d656b79d23480
    // Trapes 3D sur mon compte - compte free
    //var uid = "8fd5394c3d554e76bb9d656b79d23480";

    var version = '1.9.0';
    // var uid = 'cc89c1e265514cbab1234eba999683e1';
    // var uid = '8e02c235b92644548f2966e9bd746d8a';
    var iframe = document.getElementById('api-frame');
    var client = new window.Sketchfab(version, iframe);

    var error = function () {
      // console.error("Sketchfab API error");
    };
    var success = function (api) {
      api.addEventListener('viewerstart', function () {
        // console.log("viewerstart");
      });
      api.addEventListener('viewerstop', function () {
        // console.log("viewerstop");
      });

      api.start(function () {
        document.getElementById('start').addEventListener('click', function () {
          api.start();
        });

        document.getElementById('stop').addEventListener('click', function () {
          api.stop();
        });

        api.addEventListener('viewerready', function () {
          // console.log("viewerReady");
        });
      });
    };

    client.init(uid, {
      api_log: 0,
      annotations_visible: 0,
      autospin: 0.1,
      autostart: 1,
      camera: 0,
      double_click: 0,
      internal: 1,
      max_texture_size: 1024,
      orbit_constraint_pan: 1,
      orbit_constraint_zoom_in: 0.4,
      orbit_constraint_zoom_out: 1,
      preload: 1,
      scrollwheel: 1,
      sound_enable: 0,
      transparent: 1,
      ui_animations: 0,
      ui_annotations: 0,
      ui_ar: 1,
      ui_color: 'white',
      ui_fadeout: 0,
      ui_fullscreen: 0,
      ui_help: 0,
      ui_infos: 0,
      ui_inspector: 0,
      ui_settings: 0,
      ui_stop: 0,
      ui_theatre: 0,
      ui_vr: 0,
      ui_watermark: 0,
    });

    // client.init(uid, {
    //   api_log:0,
    //   success: success,
    //   error: error,
    //   ui_controls: 0,
    //   autostart: 1,
    //   preload: 1,
    //   transparent: 1,
    //   annotations_visible: 0,
    //   autospin: -0.1,
    //   camera: 0,
    //   double_click: 0,
    //   internal: 1,
    //   max_texture_size: 1024,
    //   orbit_constraint_pan: 1,
    //   orbit_constraint_zoom_in: 60,
    //   orbit_constraint_zoom_out: 100,
    //   scrollwheel: 1,
    //   sound_enable: 0,
    //   ui_animations: 0,
    //   ui_annotations: 0,
    //   ui_ar: 1,
    //   ui_color: "#fff",
    //   ui_fadeout: 0,
    //   ui_fullscreen: 0,
    //   ui_general_controls:0,
    //   ui_help: 0,
    //   ui_infos: 0,
    //   ui_inspector: 0,
    //   ui_settings: 0,
    //   ui_stop: 0,
    //   ui_theatre: 0,
    //   ui_vr: 0,
    //   ui_watermark: 0,
    //   ui_watermark_link: 0,
    // });
  };

  // function createCount() {
  // 	const { subscribe, set, update } = writable(0);

  // 	return {
  // 		subscribe,
  // 		increment: () => update(n => n + 1),
  // 		decrement: () => update(n => n - 1),
  // 		reset: () => set(0)
  // 	};
  // }

  // export const count = createCount();

  // export const Sketchfab = initializeRemarkable();
</script>

<svelte:head>
  <script
    src="https://static.sketchfab.com/api/sketchfab-viewer-1.9.0.js"
    on:load="{initializeRemarkable}">
  </script>
</svelte:head>

<iframe
  id="api-frame"
  title=""
  class="hero__iframe"
  width="auto"
  height="auto"
  frameborder="0"
  allow="autoplay; fullscreen; vr"
  allowvr=""
  allowfullscreen=""
  mozallowfullscreen="true"
  webkitallowfullscreen="true"
>
</iframe>

<style>
  iframe {
    position: relative;
    z-index: 100;
    width: 800px;
    height: 800px;
    border: 0;
    outline: 0;
  }
  @media only screen and (max-width: 768px) {
    iframe {
      width: 100%;
      height: auto;
      aspect-ratio: 1;
    }
  }
</style>
